import DeckMap from "../helpers/DeckMap";

export default {
  layers: {},
  deckInstance: null,
  init(deckProps) {
    this.layers = {};
    this.deckInstance = new DeckMap(deckProps);
  },
  updateDeckInstance() {
    if (!this.deckInstance) {
      return;
    }
    const layers = [...Object.values(this.layers)];
    if (this.deckInstance) {
      this.deckInstance.setProps({ layers });
    }
  },
  isVisible(id) {
    // visible = undefined is treated by deckgl as visible = true
    return this.layers[id] && this.layers[id].props.visible !== false;
  },
  getLayers() {
    return this.layers;
  },
  hasLayer(id) {
    return !!this.layers[id];
  },
  addLayer(layer) {
    if (!layer.id) {
      throw new Error(
        `[layerManager.addLayer] layer id must defined. Received "${layer.id}" instead`
      );
    }
    this.layers[layer.id] = layer;
    this.updateDeckInstance();
  },
  updateLayer(id, props) {
    if (!this.layers[id]) {
      return;
    }
    const layer = this.layers[id];
    this.layers[id] = layer.clone(props);
    this.updateDeckInstance();
  },
  updateLayersOpacity(array_of_ids, opacity) {
    for (const arrayOfId of array_of_ids) {
      if (!this.layers[arrayOfId]) {
        return;
      }
      const layer = this.layers[arrayOfId];
      this.layers[arrayOfId] = layer.clone({
        ...layer.props,
        opacity: opacity,
      });
    }
    this.updateDeckInstance();
  },
  hideAllLayers() {
    const layerIds = Object.keys(this.layers);
    for (const layerId of layerIds) {
      const layer = this.layers[layerId];
      this.layers[layerId] = layer.clone({ visible: false });
    }
    this.updateDeckInstance();
  },
  removeAllLayers() {
    this.layers = {};
    this.updateDeckInstance();
  },
  removeLayer(id) {
    if (this.hasLayer(id)) {
      delete this.layers[id];
      this.updateDeckInstance();
    }
  },
  hideLayer(id) {
    if (this.hasLayer(id)) {
      this.updateLayer(id, { visible: false });
    }
  },
  showLayer(id) {
    if (this.hasLayer(id)) {
      this.updateLayer(id, { visible: true });
    }
  },
};
